import * as React from 'react';
import { Link } from 'react-router-dom';
import { classes } from '../../components/Button';
import { Box } from '../../components/Box';
import { Guide } from '../../guide';
import { ITUNES_URL } from '../../utils/config';
import { ProfileContext, ProfileManager } from '../../profile';

type Props = {
  guide: Guide;
};

const canEditGuide = (context: ProfileManager, guide: Guide): boolean => {
  if (!context.profile) {
    return false;
  }

  return guide.user_id.toLowerCase() === context.profile.id.toLowerCase();
};

export default function GuideActions(props: Props) {
  const context = React.useContext(ProfileContext);

  return (
    <div className="flex justify-center">
      <a
        className={classes.concat(' black mh2')}
        target="_blank"
        href={`filtru://guides/public/${props.guide.public_url ||
          props.guide.id}`}
      >
        Open in Filtru
      </a>
      <a
        className={classes.concat(' black b mh2')}
        target="_blank"
        href={ITUNES_URL}
      >
        Get the app
      </a>
      {canEditGuide(context, props.guide) && (
        <Link
          to={{
            pathname: `/guides/edit/${props.guide.id}`,
            state: {
              guide: props.guide,
            },
          }}
          className={classes.concat(' black b mh2')}
        >
          Edit
        </Link>
      )}
    </div>
  );
}
